import { render } from "./UploadTest.vue?vue&type=template&id=0b00a8ac&scoped=true"
import script from "./UploadTest.vue?vue&type=script&lang=js"
export * from "./UploadTest.vue?vue&type=script&lang=js"

import "./UploadTest.vue?vue&type=style&index=0&id=0b00a8ac&scoped=true&lang=scss"

import exportComponent from "D:\\CTS_SURAJ\\CMRF\\cmrf_admin_ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b00a8ac"]])

export default __exports__